import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { FC } from "react";
import styled from "styled-components";
import { CardOption } from ".";

interface Props {
  className?: string;
  content: any;
}

const IndividualCard: FC<Props> = withErrorBoundary(
  ({ className = "", content: { title, link, linkLabel, description } }) => {
    return (
      <StyledIndividualCard className={className}>
        <h2 className="IndividualCard__title Color_eucalyptus80 Font_24_32_600 ">{title}</h2>
        <div className="IndividualCard__content">
          <div className="IndividualCard__optionRightContainer">
            <CardOption link={link} label={linkLabel} description={description} />
          </div>
        </div>
      </StyledIndividualCard>
    );
  },
  {}
);

const StyledIndividualCard = styled.div`
  padding-left: 56px;
  border-left: 1px solid ${({ theme }) => theme.colors.fog["30"]};

  .IndividualCard__title {
    padding: 12px 32px;
    background-color: ${({ theme }) => theme.colors.eucalyptus["30"]};
    border-radius: 32px;
    width: fit-content;
  }

  .IndividualCard__content {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    min-width: unset;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    padding-top: 40px;
    padding-left: unset;
    border-top: 1px solid ${({ theme }) => theme.colors.fog["30"]};
    border-left: unset;

    .IndividualCard__content {
      max-width: unset;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    padding-top: unset;
    border-top: unset;

    .IndividualCard__content {
      margin-top: 24px;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    padding-top: unset;
    border-top: none;
  }
`;

gql`
  fragment Introduction1IndividualCardContent on ComponentNestedIntroduction1Individual {
    title
    link
    linkLabel
    description
  }
`;

export { IndividualCard };
